
import { Editor, createDomElement } from "slickgrid-react";

import $ from 'jquery'
import 'spectrum-colorpicker/spectrum.js'
import 'spectrum-colorpicker/spectrum.css'
import './coloreditor.css'



export class ColorWallEditor implements Editor{
    
    $input: any  ;
    scope = this;
    args: any;
    constructor( args:any, inputType:any) {
        this.args = args;

        this.init();

    }


    
    init() {
        const self = this; // capture class instance  
        this.$input  = createDomElement('input');
        this.$input.className ='colorpicker';
      
        const cellContainer = this.args.container;

        cellContainer.appendChild(this.$input);

         //$(this.$input).css('background-color', this.args.item.color);
         (<any>$(this.$input)).spectrum({
            color_wall: this.args.item.color_wall, //$(this.args.container).css('background-color'),
            flat: false,
            showInput: true,
            allowEmpty: false,
            showInitial: true,
            clickoutFiresChange: true,
            className: 'full-spectrum',
            preferredFormat: 'hex6',
            // Show the whole set of color palette on the menu (only discrete)
            //showPalette: args.grid.selectionPalette !== undefined,
            showSelectionPalette: true,
            palette: this.args.grid.selectionPalette,
            /* On change callback */
            
            change: function(color:any) {
              const hexColor = color.toHexString();
               (<any>$(self.$input)).spectrum('set', hexColor);
  
                // ustaw tło i wartość inputa
                $(self.$input).css('background-color', hexColor);
                self.args.item.color_wall = hexColor;
               // $(self.$input).val(hexColor);
                
                
              // (<any>$(self.$input)).spectrum({
             //   color: color.toHexString(),
             // });
             //$(self).css('background-color', hexColor);
             // $(self.$input).val(hexColor);
             // (<any>$(self.$input)).spectrum('set', hexColor);
            // $($(this.$input)).val( color.toHexString());
            //this.$input.value =color.toHexString();
            }
        

         //   change: function(color:any) {
         //     (<any>$(this.$input)).spectrum({
         //       color: color.toHexString(),
         //     });
          //    $(this).css('background-color', color.toHexString());

           // }
          });

       
     
          (<any>$(this.$input))
          .spectrum('container')
          .find('.sp-input')
          .on('keydown keypress', function(e:any) {
            e.stopPropagation();
          });
       
      
      (<any>$(this.$input)).spectrum('show');

       
    }
    destroy() {}
    focus() {
      (<any>$(this.$input)).spectrum('show');
    }
    loadValue(item:any) {}
    serializeValue() {
      return (<any>$(this.$input)).spectrum('get').toHexString();
    }
    applyValue(item:any, state:any) {
      this.args.item.color_wall = state;
      item.color_wall =state
    }
    isValueChanged()  {
        return true
    }
    validate(targetElm:any, options:any)  {
        return {valid:true}
    }
    show() {
      /*
       *
       * We setup a brief timeout that gives the browser enough time to finish
       * preparing the specturm widget. If we don't wait for 100 milliseconds,
       * opening the color picker will take two clicks. This is also a
       * consequence of spectrum initializing asynchronously, by the time
       * SlickGrid executes the show method the widget is not ready yet so the
       * 'spectrum('show')' call results in a noop, and in order to show the
       * color picker users would need to click again on the colorbox.
       *
       */
      
      //this.init();
  }
  }

